var React = require('react');

function TextBoxFlag1 (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"m133.554017 63.4408445h258.111321l84.888679 217.0000005h-343z","fill":"#4eb684","fillRule":"evenodd","opacity":".084938","transform":"translate(-135 -63)"}));
}

TextBoxFlag1.defaultProps = {"height":"218","viewBox":"0 0 342 218","width":"342"};

module.exports = TextBoxFlag1;

TextBoxFlag1.default = TextBoxFlag1;
